import React from 'react';

import type { TooltipContentProps } from '@rtkwlf/fenrir-react';
import { Tooltip as RtkTooltip } from '@rtkwlf/fenrir-react';

export type TooltipProps = React.PropsWithChildren<{
  tooltip: string | React.ReactNode;
  tooltipContentProps?: TooltipContentProps;
  triggerAsChild?: boolean;
}>;

export const Tooltip = ({
  children,
  tooltip,
  tooltipContentProps = {},
  triggerAsChild = true,
}: TooltipProps) => {
  return (
    <RtkTooltip.Root>
      <RtkTooltip.Trigger asChild={triggerAsChild}>
        {children}
      </RtkTooltip.Trigger>
      <RtkTooltip.Content {...tooltipContentProps}>
        {typeof tooltip === 'string' ? (
          <RtkTooltip.Text>{tooltip}</RtkTooltip.Text>
        ) : (
          tooltip
        )}
      </RtkTooltip.Content>
    </RtkTooltip.Root>
  );
};
